export default __webpack_public_path__ + "assets/img/fontawesome-webfont.f691f37e57f04c152e2315ab7dbad881.woff";